import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const PaymentSupport = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        পেমেন্ট সাপোর্ট
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          এখানে পেমেন্ট সংক্রান্ত সমস্যা এবং সাপোর্ট দেখানো হবে।
        </Typography>
      </Paper>
    </Box>
  );
};

export default PaymentSupport; 